
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-size-guide-open]');
  const closeButton = event.target.closest('[data-size-guide-close]');

  // Open drawer
  if (trigger) {
    const drawer = document.getElementById('product-size-guide');

    if (!drawer) {
      console.error('Size guide drawer not found');
      return;
    }

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-guide-open');

    trigger.setAttribute('aria-expanded', 'true');
    return;
  }

  // Close drawer
  if (closeButton) {
    const drawer = closeButton.closest('.cc-size-guide');

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-guide-open');

      document.querySelectorAll('[data-size-guide-open]')
        .forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
    }
  }
});

// Close drawer using Escape key
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('.cc-size-guide.is-open')
      .forEach(function (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      });

    document.body.classList.remove('size-guide-open');
  }
});
